import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const LoadingTableHeaderContainer = styled(FlexRow)`
    align-items: center;
    gap: 55px;
`;

export const LoadingTableItem = styled.div`
    padding: 8px 12px;
    ${setFontVariant("captionTitle", colorsPalettes.carbon[300])};
`;

export const Spacer = styled.div`
    margin-left: auto;
`;
